import { cloneDeep, set } from 'lodash';

import { API_URL } from '@funnels/constants';
import { SERVER_CUSTOMER } from '@funnels/mockdata';
import { CustomerData } from '@funnels/types';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const CUSTOMER_URL = `${API_URL}/v1/customers`;

function fetch(customerId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const mockCustomer = cloneDeep(SERVER_CUSTOMER);
    set(mockCustomer, 'id', customerId);
    return Promise.resolve({ data: mockCustomer });
  }
  return axios.get(`${CUSTOMER_URL}/${customerId}`).then((res) => res.data);
}

function fetchMe(): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: SERVER_CUSTOMER });
  }
  return axios.get(`${CUSTOMER_URL}/me`).then((res) => res.data);
}

function addPhoneNumber(phoneNumber: string, customerId: string): Promise<any> {
  return axios.post(`${CUSTOMER_URL}/${customerId}/mobile`, { mobileNumber: phoneNumber }).then((res) => res.data);
}

function requestVerifyCode(phoneNumber: string, customerId: string): Promise<any> {
  return axios
    .post(`${CUSTOMER_URL}/${customerId}/request-phone-otp`, { mobileNumber: phoneNumber })
    .then((res) => res.data);
}

function verifyPhoneOtp(phoneNumber: string, code: string, customerId: string): Promise<any> {
  return axios
    .post(`${CUSTOMER_URL}/${customerId}/verify-phone-otp`, { mobileNumber: phoneNumber, code })
    .then((res) => res.data);
}

function update(customerId: string, customer: CustomerData): Promise<any> {
  return axios.put(`${CUSTOMER_URL}/${customerId}`, customer).then((res) => res.data);
}

export default { fetch, fetchMe, addPhoneNumber, requestVerifyCode, verifyPhoneOtp, update };
